"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var vdl_prefix_1 = require("../util/vdl-prefix");
var classnames_1 = require("../util/classnames");
var Marks = /** @class */ (function (_super) {
    __extends(Marks, _super);
    function Marks() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Marks.prototype.render = function () {
        var _a = this.props, vertical = _a.vertical, marks = _a.marks, included = _a.included, upperBound = _a.upperBound, lowerBound = _a.lowerBound, max = _a.max, min = _a.min;
        var marksKeys = Object.keys(marks);
        var marksCount = marksKeys.length;
        var unit = 100 / (marksCount - 1);
        var markWidth = unit * 0.9;
        var range = max - min;
        var elements = marksKeys
            .map(parseFloat)
            .sort(function (a, b) { return a - b; })
            .map(function (point) {
            var isActive = (!included && point === upperBound) ||
                (included && point <= upperBound && point >= lowerBound);
            var markClassName = classnames_1.classNames((_a = {},
                _a[vdl_prefix_1.vdlPrefix('slider__mark')] = true,
                _a[vdl_prefix_1.vdlPrefix('slider__mark--active')] = isActive,
                _a[vdl_prefix_1.vdlPrefix('slider__mark--min')] = point === min,
                _a[vdl_prefix_1.vdlPrefix('slider__mark--max')] = point === max,
                _a));
            var bottomStyle = {
                bottom: (point - min) / range * 100 + "%",
            };
            var leftStyle = {
                width: markWidth + "%",
                marginLeft: -markWidth / 2 + "%",
                left: (point - min) / range * 100 + "%",
            };
            var style = vertical ? bottomStyle : leftStyle;
            var markPoint = marks[point];
            var markPointIsObject = typeof markPoint === 'object' && !React.isValidElement(markPoint);
            var markLabel = markPointIsObject ? markPoint.label : markPoint;
            var markStyle = markPointIsObject ? __assign({}, style, markPoint.style) : style;
            return (React.createElement("span", { className: markClassName, style: markStyle, key: point }, markLabel));
            var _a;
        });
        return (React.createElement("div", { className: vdl_prefix_1.vdlPrefix('slider__marks') }, elements));
    };
    return Marks;
}(React.Component));
exports.Marks = Marks;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/slider/marks.js
// module id = 610
// module chunks = 0 1 2 3 4 5 6